import { IonBadge, IonCardHeader, IonCardTitle } from "@ionic/react";
import { BsThreeDots } from "react-icons/bs";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import {
  setSelectedFriend,
  toggleFriendActionModal,
} from "../../../redux/slicers/friendModalSlicer";
import { togglePostEditorModal } from "../../../redux/slicers/modalSlicer";
import getPostTime from "../../../utils/getPostTime";
import RatingBtn from "../../button/RatingBtn";

const PostHeader = ({
  author,
  createdAt,
  post,
  isVideoOnly,
  whiteText,
  isReposted,
}) => {
  const { username, isAdmin } = useSelector(
    (state) => state.currentProfile.data,
  );
  const dispatch = useDispatch();

  const isMyPost = username === author.username;

  const handleMyPostClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    dispatch(togglePostEditorModal(post));
  };

  const handleOtherUserClick = (e, author) => {
    e.preventDefault();
    e.stopPropagation();
    dispatch(setSelectedFriend({ user: author, post }));
    dispatch(toggleFriendActionModal(author));
  };
  const truncate = (str, maxLength) => {
    if (!str) return "";
    return str.length > maxLength ? str.slice(0, maxLength - 1) + "…" : str;
  };
  return (
    <IonCardHeader className="w-full justify-content-c">
      <div
        className={`display-flex justify-content-sb align-items-c ${
          isVideoOnly ? "post__header--video" : ""
        }
`}
      >
        <div className="display-flex align-items-c">
          {/* <Avatar
            username={post.author.username}
            avatar={post.author.avatar}
            size="small"
          /> */}
          <Link
            className={`post__profile display-flex align-items-c ${
              isVideoOnly ? "post__profile--video" : ""
            }`}
            style={{
              flex: 1, // Occupy available space
              minWidth: 0, // Crucial: allows the container to shrink
            }}
            to={`/profile/${author.username}`}
          >
            {/* <IonCardTitle className={`post__profile--name ${isVideoOnly ? "text-white" : ""}`}>
              {author.fname} {author.lname}
            </IonCardTitle> */}
            <div
              style={{
                flexDirection: "column",
                display: "flex",
              }}
            >
              <IonCardTitle
                className={`post__profile--username poetsen ${
                  isVideoOnly || whiteText ? "text-white" : ""
                }`}
                style={{
                  display: "-webkit-box",
                  WebkitLineClamp: 2, // Limits text to 2 lines
                  WebkitBoxOrient: "vertical",
                  overflow: "hidden", // Hides the rest
                  lineHeight: "1.2", // Adjust based on your font
                  wordBreak: "break-word", // Ensures long strings without spaces also wrap
                }}
              >
                {author.username}
              </IonCardTitle>
              <span
                className={`post__profile--location ${
                  isVideoOnly || whiteText ? "text-white" : ""
                }`}
              >
                {[author.city, author.province].filter(Boolean).join(", ")}
                {author.city || author.province ? " · " : ""}
                {getPostTime(createdAt)}
              </span>
              {/* <p
                className={`post__profile--time ${isVideoOnly || whiteText ? "text-white" : ""}`}
              >
              </p> */}
            </div>
          </Link>
          {/* Pinned/Featured Badges */}
          {(post.isPinned || post.isFeatured) && (
            <div style={{ display: "flex", gap: "8px", marginLeft: "8px" }}>
              {post.isPinned && (
                <IonBadge
                  style={{
                    fontSize: "11px",
                    fontWeight: "600",
                    backgroundColor: "#fceabb",
                    color: "#000",
                    padding: "4px 8px",
                    borderRadius: "8px",
                  }}
                >
                  📌
                </IonBadge>
              )}
              {post.isFeatured && (
                <IonBadge
                  style={{
                    fontSize: "11px",
                    fontWeight: "600",
                    backgroundColor: "#F9E2A8",
                    color: "#000",
                    padding: "4px 8px",
                    borderRadius: "8px",
                  }}
                >
                  ⭐
                </IonBadge>
              )}
            </div>
          )}
        </div>
        <div className="post__profile-time-more">
          <RatingBtn
            id={post._id}
            ratings={post.ratings}
            className={isReposted && "display-none"}
          />
          <BsThreeDots
            className="post-btns__btn"
            onClick={
              isMyPost || isAdmin
                ? handleMyPostClick
                : (e) => handleOtherUserClick(e, author)
            }
          />
        </div>
      </div>
    </IonCardHeader>
  );
};

export default PostHeader;
